import React from 'react';
import PropTypes from 'prop-types';
import { get, map } from 'lodash';
import { SanitizeHtml, Image, Slugify } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import AccordionToggle from '../../components/AccordionToggle';
import { colors } from '../../styles';

const styles = css`
  padding: 45px 0 30px 0;
  position: relative;
  @media (min-width: 992px) {
    padding: 120px 0 60px 0;
    background-image: url('/images/homebuilder-tech-logo.png');
    background-position: 70vw -10vh;
    background-size: 60vh auto;
    background-repeat: no-repeat;
  }
  .Agenda_bannerHeading {
    font-size: 48px;
    font-weight: 700;
    margin: 0 0 90px 0;
    @media (min-width: 992px) {
      font-size: 60px;
    }
  }
  .Agenda_dayList {
    list-style: none;
    margin: 0 0 75px 0;
    padding: 0;
  }
  .Agenda_dayItemTitle {
    border-bottom: 3px solid #000000;
    padding: 0 75px 10px 0;
    margin: 0 0 30px 0;
    font-weight: 700;
    font-size: 26px;
    background-image: url('/images/icon-minus.svg');
    background-position: right center;
    background-repeat: no-repeat;
    background-size: 15px 5px;
    @media (min-width: 992px) {
      font-size: 32px;
    }
  }
  .Agenda_timeList {
    list-style: none;
    margin: 0 0 45px 0;
    padding: 0;
  }
  .Agenda_timeItemTitle {
    font-size: 20px;
    line-height: 1;
    margin: 0 0 10px 0;
    padding: 0 0 0 28px;
    background-image: url('/images/icon-clock.svg');
    background-repeat: no-repeat;
    background-size: 20px 20px;
    small {
      font-size: 14px;
    }
  }
  .Agenda_eventList {
    list-style: none;
    margin: 0 0 15px 0;
    padding: 0;
  }
  .Agenda_eventItem {
    padding: 15px 15px;
    border: 1px solid #cccccc;
    margin: 0;
    background-color: #F5F5F5;
    position: relative;

    &-active {
      border: 5px solid #DB2150;
    }
  }
  .Agenda_eventItemTitle {
    font-weight: 700;
    font-size: 18px;
    line-height: 1.2;
    margin: 0;
    @media (min-width: 992px) {
      width: 60%;
    }
  }
  .Agenda_eventDescription {
    margin: 25px 0 0 0
  }
  .Agenda_speakersTextList {
    list-style: none;
    margin: 8px 0 0 0;
    padding: 0;
    @media (min-width: 992px) {
      width: 60%;
    }
  }
  .Agenda_speakersTextListItem {
    display: inline-block;
    border-right: 1px solid #CCCCCC;
    padding: 0 10px 0 0;
    margin: 0 10px 0 0;
    line-height: 1;
    &:last-child {
      border: 0;
    }
  }
  .Agenda_speakersTextListItemHeading {
    padding: 3px 10px;
    background-color: ${colors.color1Lightest};
    display: inline-block;
    line-height: 1;
    margin: 0 10px 0 0;
    font-weight: 700;
    &.arvrai {
      background-color: #D7DD3A;
    }
    &.content-strategy {
      background-color: #e53b66;
    }
    &.webseo {
      background-color: #FAAF4C;
    }
    &.technology-strategy {
      background-color: #333333;
      color: #FFFFFF;
    }
  }
  .Agenda_speakerPhotoList {
    position: relative;
    padding: 0;
    margin: 10px 0 0 0;
    @media (min-width: 992px) {
      position: absolute;
      right: 15px;
      top: 15px;
      padding: 0;
      margin: 0;
      text-align: right;
      width: 39%;
      margin: 0;
    }
  }
  .Agenda_speakerPhotoListItem {
    display: inline-block;
    margin: 10px 0 0 10px;
    img {
      border-radius: 100%;
    }
  }

  .Agenda_eventScrollTarget {
    position: absolute;
    top: -50px;
  }
  .Agenda_eventMore {
    height: 40px;
  }
  .Agenda_eventMoreIcon {
    margin: 0 0 0 -5px;
    width: 38px;
  }
`;

function AgendaTable({ page, widget }) {
  return (
    <div className={styles} id="agenda">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h1 className="Agenda_bannerHeading">Homebuilder Tech Agenda</h1>

            {get(page, 'schedule[0].days', []).map(day => (
              <ul key={day._id} className="Agenda_dayList">
                <li className="Agenda_dayItem">
                  <AccordionToggle
                    button={() => (<h2 className="Agenda_dayItemTitle">{get(day, 'day_title')}</h2>)}
                    isOpen
                  >

                    {day.times.map(time => (
                      <ul key={time._id} className="Agenda_timeList">
                        <li className="Agenda_timeItem">
                          <h3 className="Agenda_timeItemTitle">{get(time, 'time')} <small><em>Eastern Time</em></small></h3>
                          {time.event.map(event => {
                            const speakers = widget.speakers
                              .filter(speaker => map(event.speakers, 'speaker').includes(speaker._id));
                            return (
                              <ul className="Agenda_eventList" key={event.title}>
                                <li className={`Agenda_eventItem ${(window.location.hash || '').replace('#', '') === Slugify(event.title) ? 'Agenda_eventItem-active' : ''}`}>
                                  <span className="Agenda_eventScrollTarget" id={Slugify(event.title)} />
                                  <AccordionToggle
                                    openOnId={Slugify(event.title)}
                                    button={() => (
                                      <div>
                                        <h4 className="Agenda_eventItemTitle">{get(event, 'title')}</h4>
                                        {
                                          speakers.length > 0 &&
                                          <ul className="Agenda_speakersTextList">
                                            {
                                              event.company &&
                                              <li className={`Agenda_speakersTextListItemHeading ${Slugify(event.company)}`}>{event.company}</li>
                                            }
                                            {speakers.map(speaker => (
                                              <li key={speaker._id} className="Agenda_speakersTextListItem">
                                                <Link name="speakers" hash={`#${Slugify(speaker.name)}`}>{speaker.name}</Link>
                                              </li>
                                              ),
                                            )}
                                          </ul>
                                        }
                                        {
                                          speakers.length > 0 &&
                                          <ul className="Agenda_speakerPhotoList">
                                            {speakers.filter(s => get(s, 'headshot.contentUrl')).map(speaker => (
                                              <li key={speaker._id} className="Agenda_speakerPhotoListItem">
                                                <Link name="speakers" hash={`#${Slugify(speaker.name)}`}>
                                                  <Image
                                                    src={get(speaker, 'headshot.contentUrl')}
                                                    alt={speaker.name}
                                                    width={60}
                                                    height={60}
                                                    exact
                                                  />
                                                </Link>
                                              </li>
                                              ),
                                            )}
                                          </ul>
                                        }
                                        <div className="Agenda_eventMore">
                                          {
                                            event.description &&
                                            <div>
                                              <img className="Agenda_eventMoreIcon" src="/images/icon-more.svg" alt="" /> <small>MORE</small>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    )}
                                  >
                                    {
                                      event.description &&
                                      <div className="Agenda_eventDescription" dangerouslySetInnerHTML={SanitizeHtml(get(event, 'description'))} />
                                    }
                                  </AccordionToggle>
                                </li>
                              </ul>
                            );
                          },
                        )}

                        </li>
                      </ul>
                      ),
                    )}
                  </AccordionToggle>
                </li>
              </ul>
              ),
            )}

          </div>
        </div>
      </div>
    </div>
  );
}

AgendaTable.propTypes = {
  page: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default AgendaTable;



// WEBPACK FOOTER //
// ./src/pages/Agenda/AgendaTable.js